<template>
  <div class="page">
    <!-- <div class="top" @click="back()">
      <p>
        <img src="https://img.yzcdn.cn/upload_files/2020/04/03/Fu1OESUm3NJYRRgDhqk7Ar6Yh-No.png" />
        返回
      </p>
    </div> -->
    <banner-top title="" />
    <!-- <div class="mb21"></div> -->
    <div v-if="catalogueData.extrapolationEnabled" class="sameQuestionTip flex-row flex-al-center">
      <img src="https://img01.yzcdn.cn/upload_files/2021/09/15/FlfGe418xqefCwAR8x1-cmGl63KC.png" />
      <span>本书已开放举一反三功能，快去体验吧！</span>
    </div>
    <div class="main">
      <div class="book_detail">
        <div class="book_img">
          <!-- <img :src="catalogueData.picurl ? `/cms/upload/cover/` + catalogueData.picurl : ''" /> -->
          <div v-if="newest" class="newest2"></div>
          <div v-if="isAnswer" class="isAnswer"></div>
          <img v-lazy="imgObj || {}" />
          <div v-if="isWillonLine" class="mask">
            <img
              class="mask_img"
              src="https://img.yzcdn.cn/upload_files/2020/04/27/FlfRIAUaXlOFLUzWhG5ThhPG_lww.png"
            />
            <div class="name">即将上线</div>
          </div>
        </div>
        <div class="book_title flex-col flex-jc-bt">
          <div>
            <h3>{{ catalogueData.book.renderTagName }}</h3>
            <div class="book_sub_title_one flex-row">
              <div class="book_sub_title_course book_sub_title_pub">
                {{ catalogueData.book.courseName }}
              </div>
              <div v-if="catalogueData.book" class="book_sub_title_gc book_sub_title_pub">
                {{ catalogueData.book.gradesName }}{{ catalogueData.book.renderVolumeName }}
              </div>
            </div>
          </div>
          <div v-if="catalogueData.book.category !== 'yuedu'" class="book_sub_title_two">
            <div class="book_sub_title_version">
              <version-name :books="catalogueData.book" :length="5" />
            </div>
          </div>
          <shujia ref="shujiaRef" :book-info="catalogueData" />
          <!-- <p>{{ catalogueData.descrip }}</p> -->
          <!-- 展示规则  -->
          <!-- <div v-if="isShell && !hasRight.hasRight" class="relactive" @click="related">
            相关课程<img
              src="https://img.yzcdn.cn/upload_files/2020/09/02/Fsh4FOcfHLmPipMiy3rQ2IVjwylM.png"
            />
          </div> -->
          <!--<RedeemBook
            v-if="isShell && !hasRight.hasRight"
            :workbook-id="workbook_id"
            :catalogue-data="catalogueData"
          /> -->
        </div>
      </div>
      <!-- 家长锁 -->
      <!-- <Parentslock v-if="jiazhangsuoShow" /> -->
      <!-- 正常目录部分  v-if="ids.length > 0"-->
      <!-- 增加新旧版本提醒 -->
      <div v-if="isShowRemind" class="remind" @click="navigate()">
        <span>此书为旧版，点我查看最新版本</span>
        <img
          src="https://img01.yzcdn.cn/upload_files/2021/08/13/FuvvsPe5l5K4_bpS26GexfKLQe8O.png"
        />
      </div>
      <div v-if="isAnswer" class="Answer_Tips">
        <div class="Answer_Tips_title">
          温馨提示：
        </div>
        <div class="Answer_Tips_desc">
          本书仅提供<span class="Answer_Tips_desc_red">参考答案且全部免费看</span>
          ！如需详细内容及答案解析可申请制作，平台会根据图书需求量排名逐一制作。
        </div>
      </div>
      <div>
        <div v-for="(item, index) in chaptersData" :key="index" class="catalogue">
          <p class="catalogue_title">{{ item.title }}</p>
          <div
            v-for="(page, index1) in item.pages"
            :key="index1"
            class="catalogue_number"
            @click="toAnswerPage(item, page)"
          >
            <span
              :class="{
                noright: (index1 + 1) % 6 == 0,
                border_red: pageIdList.join(',').indexOf(page.id) >= 0
              }"
            >
              {{ page.pageName }}
            </span>
            <!-- 小锁icon v-if="!hasRight.hasRight && page.pageno >= 6" -->
            <!-- 展示锁 -->
            <!-- <div v-if="showLock(page)" class="lock">
              <img
                src="https://img.yzcdn.cn/upload_files/2020/09/01/Fh7bdFms8WXMUZMdp3GqJVgdIdbK.png"
              />
            </div> -->
          </div>
        </div>
      </div>
      <!-- 即将上线的书籍 -->
      <div v-if="isWillonLine" class="no_up_page">
        <img src="https://img.yzcdn.cn/upload_files/2020/04/24/Fsdv54jUZE130nakitrsD00v1N9V.png" />
        <div class="tip_top">订阅此书，上线后第一时间通知您</div>
        <div class="tip_middle">(预计上线时间{{ onlineDate }})</div>
        <button
          :class="subscribe ? 'gray' : ''"
          :disabled="subscribe"
          @click="subscribeWbOnlineInfo"
        >
          {{ subscribe ? '已订阅' : '点我订阅' }}
        </button>
      </div>
    </div>
    <div class="baidu_fixed_wrap">
      <div class="baidu_textBook"></div>
    </div>
    <!--    <div v-if="catalogueData.category" class="bottom">-->
    <!--      <div class="book_case" @click="kefu">-->
    <!--        <img-->
    <!--          src="data:image/svg+xml,%3Csvg width='23' height='23' viewBox='0 0 23 23' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2.92 10.664a.713.713 0 0 1 .713.713v2.85a.713.713 0 1 1-1.426 0v-2.85a.713.713 0 0 1 .713-.713zm0-2.138a2.85 2.85 0 0 0-2.85 2.851v2.85a2.85 2.85 0 0 0 5.7 0v-2.85a2.85 2.85 0 0 0-2.85-2.85zm17.103 2.138a.713.713 0 0 1 .713.713v2.85a.713.713 0 0 1-1.425 0v-2.85a.712.712 0 0 1 .712-.713zm0-2.138a2.85 2.85 0 0 0-2.85 2.851v2.85a2.85 2.85 0 1 0 5.7 0v-2.85a2.85 2.85 0 0 0-2.85-2.85z' fill='%23333'/%3E%3Cpath d='M4.345 9.46v-.121a7.126 7.126 0 1 1 14.253 0v.121h2.138v-.121a9.264 9.264 0 0 0-18.529 0v.121h2.138zm7.404 12.471a1.069 1.069 0 1 1 0-2.138c5.944 0 7.198-3.848 7.248-4.012a1.069 1.069 0 0 1 2.083.189c.014.137.002.277-.038.41-.057.206-1.682 5.551-9.293 5.551z' fill='%23333'/%3E%3Cpath d='M11.037 18.724h1.425c1.425 0 2.138.713 2.138 2.138 0 1.425-.713 2.138-2.138 2.138h-1.425c-1.426 0-2.138-.713-2.138-2.138 0-1.425.712-2.138 2.138-2.138z' fill='%23333'/%3E%3C/svg%3E"-->
    <!--        />-->
    <!--        <p>咨询</p>-->
    <!--      </div>-->

    <!--      &lt;!&ndash; ios/其他书籍类型 sv 和机构用户展示 &ndash;&gt;-->
    <!--      <div v-if="!isShell || hasRight.hasAnswerRight" class="handle">-->
    <!--        <span class="correlation" @click="related">相关课程</span>-->
    <!--        <span class="vip" @click="toVip('svip_ymy_hymf_gn')">会员免费</span>-->
    <!--      </div>-->
    <!--      &lt;!&ndash; 课本练习册 &ndash;&gt;-->
    <!--      &lt;!&ndash; 已订阅 &ndash;&gt;-->
    <!--      <div v-if="isShell && hasRight.bookRight && !hasRight.hasAnswerRight" class="handle">-->
    <!--        <span class="correlation" @click="toVip('svip_ymy_hymf_gn')">开通会员</span>-->
    <!--        <span class="vip">已订阅</span>-->
    <!--      </div>-->
    <!--      &lt;!&ndash; 未订阅 &ndash;&gt;-->
    <!--      <div v-if="isShell && !hasRight.hasRight" class="handle shell">-->
    <!--        &lt;!&ndash;开通作业宝 &ndash;&gt;-->
    <!--        <div>-->
    <!--          <img-->
    <!--            src="https://img.yzcdn.cn/upload_files/2020/12/04/FtOaYvQDn7rsxDdP5jAp-nAwktl8.png"-->
    <!--            class="xianshi"-->
    <!--          />-->
    <!--          <span class="correlation" @click="ZybToVip('zyb12hd_yey_129vip_gn')">-->
    <!--            <div>{{ $env.isIos ? '开通作业宝' : '99元一年作业宝' }}</div>-->
    <!--          </span>-->
    <!--        </div>-->
    <!--        <span class="vip" @click="toShellPay('db_ymy_n_gn')">-->
    <!--          <div v-if="!$env.isIos">-->
    <!--            <p>¥</p>-->
    <!--            {{ price }}-->
    <!--          </div>-->
    <!--          立即订阅-->
    <!--        </span>-->
    <!--      </div>-->
    <!--    </div>-->
    <!-- bottom部分 -->
    <div v-if="isAnswer" class="answer_bottom">
      <div class="answer_bottom_btn" @click.stop="AnswerToMake">申请制作书籍</div>
    </div>
    <!--    <div-->
    <!--      v-if="hasRight.bookRight"-->
    <!--      class="answer_bottom"-->
    <!--      style="height: 3rem"-->
    <!--      @click="toShellPay('db_ymy_n_gn')"-->
    <!--    >-->
    <!--      <div class="answer_bottom_btn">立即订阅</div>-->
    <!--    </div>-->
    <bottom2danben v-if="isShowBottom && !hasRight.bookRight" @right="toShellPay('db_ymy_n_gn')" />
    <bottom v-if="isShowBottom && hasRight.bookRight" />

    <div v-if="BottomTengImgList" class="byOneself_AD">
      <div :class="externalOrg === 0 ? '' : 'outerAd'">
        <img :src="BottomTengImg" class="byOneself_AD-img" @click="byOneselfLink" />
        <img
          src="https://img.yzcdn.cn/upload_files/2020/11/09/Fv3ZJ0-xeUo3Tld3TBnER9nvdNT-.png"
          class="byOneself_AD-close"
          @click="BottomTengImgList = false"
        />
      </div>
    </div>
    <div class="TCAD_WRAP">
      <div id="TCAD_pageNum" class="TCAD_pageNum"></div>
    </div>
    <!-- <Checkedterm
      v-if="checkedtermAlert"
      :is-show="checkedtermAlert"
      :picurl="catalogueData.thumbCoverPath"
      :workbook_id="workbook_id"
    /> -->
    <VolumeAlert
      v-if="topAlertisShow"
      :is-ahow="topAlertisShow"
      :book-type="bookVolume"
      :workbook-id="workbook_id"
      :catalogue-data="catalogueData.book"
      :img-url="imgObj"
      @showConfirmAlert="hiddenVolumeAlert"
      @toPaymentPages="toShellPay('db_ymy_n_gn', 'toPayment')"
    />
    <find-book
      :is-search="false"
      :show="isShowAnswerToMake"
      @on-back="() => (isShowAnswerToMake = false)"
    />
  </div>
</template>

<script>
import { Col, Row, Toast, Overlay, CountDown } from 'vant'
import {
  qs,
  format,
  getCookie,
  changeDocTitle,
  relodPage,
  transPrice,
  setCookieData,
  setCookie
} from '@/static/js/zjs.js'
import { open } from '@/plugin/popup'
import kebenCookie from '../../../../cookie/kebenLock'
import { getMopaAd } from '@/api/ad'
import { adModel, getPlatform } from '../../../../../library'
import { hideTCAD, renderTCAD } from '@/plugin/TCAD'
// import Checkedterm from './component/checkedTermAlert'
// 购买上册，二次确认弹窗
import VolumeAlert from './component/volumeOneConfirmAlert'
import shujia from '../../component/shujia'

// 兑换码兑换图书
// import RedeemBook from './component/redeemBook'
import bottom from '../../component/bottom2'
import bottom2danben from '../../component/bottom2danben'
import { deleteCollect } from '@/api/collectBook'
import { transformOssbookDictionary } from '@/static/js/business'
import BannerTop from '@/components/BannerTop'
import { assistanceLink, queryNewestBookList } from '@/api/answer'
import VersionName from '@/pages/vipHome/route/book/mjBookList/components/versionName.vue'
import FindBook from '@/pages/answer/component/findBook'
import { showRemoveBookRackModal } from '@/pages/answer/adModels'

const appid = getPlatform().appid
const fsc = function(i, t) {
  if (t === void 0) return getCookie(i)
  setCookie(i, t)
}
export default {
  name: '',
  components: {
    FindBook,
    // Checkedterm,
    [Row.name]: Row,
    [Col.name]: Col,
    [Toast.name]: Toast,
    [Overlay.name]: Overlay,
    [CountDown.name]: CountDown,
    VolumeAlert,
    // RedeemBook,
    shujia,
    BannerTop,
    bottom,
    bottom2danben,
    VersionName
  },
  data() {
    return {
      isShowRemind: false, // 是否展示新旧版本提醒
      newestWorkbook_id: '', // 最新版的书籍id
      catalogueData: {
        book: {
          courseName: '',
          versionName: '',
          gradesName: ''
        }
      }, // 课本源数据
      bookVolume: false, // 书籍上下册展示
      chaptersData: [], // 章节源数据
      title: '', // doc的title
      workbook_id: '', // 书的id
      openid: '',
      oldShow: false, // 旧书籍弹框
      onlineDate: '', // 即将上线日期
      subscribe: false, // 即将上线书籍订阅btn控制
      pageIdList: [],
      ids: [],
      effectiveDaeffectiveDatete: 0,
      hasRight: {}, // 权限json
      checkedtermAlert: false,
      freeAnswerArr: [], // 存储完成任务后可以查看的页面id
      topAlertisShow: false, // 上册二次弹窗
      taskNumber: 0, // 剩余免费查看次数
      // taskAlertUrl: 'https://img.yzcdn.cn/upload_files/2020/11/10/FnE3zF91CUG5wyYgxTjNF6FBHXtS.png',
      BottomTengImg: '', // 新增页码页底部广告图片
      BottomTengImglink: '', // 新增页码页底部广告图片跳转链接
      BottomTengImgList: false,
      externalOrg: null,
      Friends_help: '',
      loaded: false,
      isShowAnswerToMake: false,
      isShanxi: false
    }
  },
  computed: {
    userInfo() {
      return this.$store.userInfo
    },
    // 单本售卖书的价钱
    price() {
      return transPrice(this.hasRight.bookData.price, true)
    },
    // 是否单独售卖 课本和练习册
    isShell() {
      if (this.isShanxi) {
        return false
      } else {
        return ['keben', 'jiaofu'].includes(this.catalogueData.category)
      }
    },
    isShowBottom() {
      return this.isShell && this.loaded && !this.isSV_JG
    },
    // 会员或者机构用户
    isSV_JG() {
      return this.hasRight.answerRights.hasVipRight || this.hasRight.answerRights.isStoreUserPerm
    },
    imgObj() {
      return {
        src: this.$env.ossUrl(this.catalogueData.thumbCoverPath),
        error: 'https://img.yzcdn.cn/upload_files/2019/12/18/FiHMp7Sh-y_HisCBRFnxeHg-eQWD.png',
        loading: 'https://img.yzcdn.cn/upload_files/2019/12/18/FiHMp7Sh-y_HisCBRFnxeHg-eQWD.png'
      }
    },
    // 是否定时上线
    isWillonLine() {
      if (!this.catalogueData.book) return false
      return this.catalogueData.book.enabled === 2 && this.catalogueData.book.enabledEndDay
    },
    // 检查是否是仅参考答案
    isAnswer() {
      const p = ['keben_answer', 'jiaofu_answer']
      return p.includes(this.catalogueData.category)
    },
    // 新上架14天以内，显示最新上架
    newest() {
      const timing = 1000 * 3600 * 24 * 14
      const timeDifference = new Date() - new Date(this.catalogueData.createTime || 0)
      return timeDifference > 0 && timeDifference < timing
    },
    // 是否是山西平台
    platform() {
      return appid === 'wxdbffc41fa60453a9' || appid === 'wxa432270a25dd972f'
    },
    answerTaskLink() {
      // 好友助力下线
      // return this.platform
      //   ? 'https://img01.yzcdn.cn/upload_files/2021/02/20/FpbYUydQgvItJCJ5CFJAKDfdykjG.png'
      //   : 'https://img01.yzcdn.cn/upload_files/2021/02/23/FgzenX_OWN1z67QDbBGwyDFXA11u.png'
      return 'https://img01.yzcdn.cn/upload_files/2021/02/20/FpbYUydQgvItJCJ5CFJAKDfdykjG.png'
    }
  },
  watch: {
    '$route.query.id': function(newval) {
      this.createdMethod()
      this.mountedMethod()
    }
  },
  created() {
    this.createdMethod()
  },
  mounted() {
    this.mountedMethod()
    this.countDown()
  },
  beforeDestroy() {
    hideTCAD(0)
  },
  methods: {
    format,
    changeDocTitle,
    relodPage,
    transPrice,
    countDown() {
      const nowDate = new Date()
      const endDate = new Date('2021/12/31,23:59:59')
      // const endDate = new Date('2021/12/31,23:59:5s9')
      const platForm = getPlatform().platform === 'shanxi'
      const leftDate = parseInt(endDate.getTime() - nowDate.getTime()) / 1000
      if (leftDate <= 0) {
        this.isShanxi = false
      } else {
        this.isShanxi = platForm
      }
      setTimeout(this.countDown, 1000)
    },
    // 申请制作书籍
    AnswerToMake() {
      console.log('我是申请制作')
      this.isShowAnswerToMake = true
    },
    initBaiduAd() {
      var adEle = document.querySelector('#banner_2_0')
      if (adEle) {
        adEle.style.display = 'none'
      }
      if (this.$store.userInfo.vipLevel !== 'sv') {
        this.$http
          .get(`/cms/webapp/home/static/platform.json?${new Date().valueOf()}`)
          .then((res) => {
            if (res.data.baiduAd && res.data.baiduAd[0]) {
              this.$nextTick(() => {
                ;(window.slotbydup = window.slotbydup || []).push({
                  id: res.data.baiduAd[0].id,
                  container: 'baidu_textBook',
                  async: true
                })
              })
            }
          })
      }
    },
    kefu() {
      u.go('/cms/webapp/home/info/qiyukf-session.html')
    },
    createdMethod() {
      this.workbook_id = this.$route.query.id
      this.openid = this.$store.openid

      /*
        获取cookie中的做过任务的页面id数组
      */
      var freeAnswer = getCookie('answerAuthority')
      if (freeAnswer) {
        this.freeAnswerArr = freeAnswer.split(',')
      } else {
        this.freeAnswerArr = []
      }
    },
    async mountedMethod() {
      setCookieData('taskBookId', this.$route.query.id)
      // 获取可观看页abcd
      this.$http.get('/cms/weixin/wb/answer/getSyce/' + this.$store.openid).then((res) => {
        this.taskNumber = res.data.data
      })
      this.relodPage()
      // this.getPreIndex()

      u.ui.ing()
      // 权限
      this.getBookPageJosn(this.workbook_id).then((bookData) => {
        this.$store
          .dispatch('answerRight/getCompleteRightByBookId', {
            workbookId: this.workbook_id,
            category: bookData.category
          })
          .then((res) => {
            transformOssbookDictionary(bookData).then(() => {
              this.catalogueData = bookData
              this.tip()
              this.loaded = true
              u.ui.clr()

              this.chaptersData = bookData.chapters
              this.testTongji()
              // 动态改变title
              this.changeDocTitle(this.catalogueData.name || this.catalogueData.abbrName)
              // 旧年份书籍
              // if (bookData.book.latestPublishYear === 0) {
              //   open({
              //     name: 'OverlayOldBook',
              //     expired: true
              //   })
              // }
              // 定时上线日期
              if (this.catalogueData.book.enabledEndDay) {
                this.onlineDate = this.format(
                  'yyyy年MM月dd日',
                  this.catalogueData.book.enabledEndDay
                )
              }
              this.hasRight = res
              console.log('wo shi hasright', res)
            })
          })
      })
      this.getWbOnlineSubscribe()
      this.pageIdList = (getCookie('dataList' + this.workbook_id) || '').split(',')
      await queryNewestBookList(this.workbook_id)
        .then((res) => {
          const { data } = res.data
          if (data.length === 0) {
            this.isShowRemind = false
          } else if (data && data[0]) {
            this.isShowRemind = true
            this.newestWorkbook_id = data[0].bookId
          }
        })
        .catch((err) => {
          console.log(err)
        })
      // 暑假作业订阅弹窗
      // await this.checkSummerAssignmentSubscriptionStatus()
      // await this.answerTaskhelp()
      await this.textBookAd()
      // await this.textBookAd()
      //  广告加载，变换样式
      // 广告弹窗
      await this.getModal()
      // this.initBaiduAd()
    },
    async SeenThatDay(page) {
      return await this.$store.dispatch('answerRight/getFreeCheckStatus', {
        pageId: page.id,
        workbookId: this.workbook_id,
        category: this.catalogueData.category
      })
    },
    getPublishYearImg(year) {
      return `/cms/static/images/new/${year}.png`
    },
    // 隐藏购买上册二次弹窗
    hiddenVolumeAlert() {
      this.topAlertisShow = false
    },
    // 此书为旧版，点我查看最新版本
    navigate() {
      this.$router.push({
        url: '/textbookDetails',
        query: {
          id: this.newestWorkbook_id
        }
      })
    },
    // 展示锁
    showLock(page) {
      if (this.catalogueData.category === 'keben') {
        return false
      }

      // 做任务，免费查看当前页
      if (
        getCookie('answerAuthority')
          .split(',')
          .includes(page.id.toString())
      ) {
        return false
      }

      // 连续做任务，免费看3页
      if (this.taskNumber > 0) {
        return false
      }
      if (
        getCookie('taskPageId')
          .split(',')
          .includes(page.id.toString())
      ) {
        return false
      }

      // return !this.hasRight.hasRight && this.pageIndex(page)
    },
    back() {
      this.$router.back()
    },
    // 存储免费产看过的答案页id
    taskPageId(id) {
      const cookiePageId = getCookie('taskPageId')
      if (cookiePageId) {
        const pageIdArr = cookiePageId.split(',')
        pageIdArr.push(id)
        setCookieData('taskPageId', pageIdArr)
      } else {
        const pageIdArray = []
        pageIdArray.push(id)
        setCookieData('taskPageId', pageIdArray)
      }
    },
    // 河北做任务好友助力链接
    // async answerTaskhelp() {
    //   await assistanceLink().then((res) => {
    //     if (res.data.status === 200) {
    //       this.Friends_help = res.data.data.urlPath
    //     }
    //   })
    // },
    // 有无权限跳转答案页
    async hasRightLinkToAnswer(page) {
      // 5页之内，或者有权限看书 !this.pageIndex(page) ||
      var jurisdiction = await this.SeenThatDay(page)
      if (this.hasRight.hasRight || jurisdiction) {
        return true
      } else if (
        getCookie('answerAuthority')
          .split(',')
          .includes(page.id.toString())
      ) {
        // 判断当前的页，是否查看过广告任务,如果查看过，跳转到此页
        return true
      } else if (this.taskNumber > 0) {
        // 连续做任务，免费看3页
        // this.taskPageId(page.id)
        return true
      } else if (
        getCookie('taskPageId')
          .split(',')
          .includes(page.id.toString())
      ) {
        return true
      } else {
        // 没权限5页之外，课本免费看空白页
        if (this.catalogueData.category === 'keben') {
          if (!kebenCookie.get(this.workbook_id)) {
            return true
          }
        }
        return false
      }
    },
    byOneselfLink() {
      this.$trackevent({
        type: 'funcTracker',
        action: 'click',
        opt_label: '答案核对下方广告'
      })
      if (this.BottomTengImglink) {
        location.href = this.BottomTengImglink
      }
    },
    async toAnswerPage(item, page) {
      if (!(await this.hasRightLinkToAnswer(page))) {
        // 做完任务后的操作
        if (this.taskNumber === 0 && getCookie('taskRunOut') === 'true') {
          if (window._hmt) {
            window._hmt.push(['_trackEvent', 'funcTracker', 'show', '好友助力_show'])
          }
          adModel({
            img: this.answerTaskLink,
            hotspot: [
              // {
              //   top: '62',
              //   bottom: '24',
              //   left: '5',
              //   right: '5',
              //   click: () => {
              //     // 任务已做完，免费查看次数已用完
              //     if (this.Friends_help && !this.platform) {
              //       if (window._hmt) {
              //         window._hmt.push(['_trackEvent', 'funcTracker', 'click', '好友助力_click'])
              //       }
              //       window.location.href = this.Friends_help
              //     }
              //   }
              // },
              {
                top: '80',
                bottom: '7',
                left: '5',
                right: '5',
                click: () => {
                  if (window._hmt) {
                    window._hmt.push([
                      '_trackEvent',
                      'funcTracker',
                      'click',
                      '答案页-开通会员_click'
                    ])
                  }
                  this.toVip('svip_daan_tch_gn')
                }
              }
            ]
          })
        } else {
          // 没有权限开始做任务
          if (window._hmt) {
            window._hmt.push(['_trackEvent', 'funcTracker', 'show', '做任务_show'])
          }
          const model = adModel({
            img: 'https://img01.yzcdn.cn/upload_files/2022/08/16/Flw9QKAlkSmGrkGw37L3glmYMpYJ.png',
            hotspot: [
              {
                top: '60',
                bottom: '5',
                left: '5',
                right: '5',
                click: () => {
                  // 跳转连续做任务页面
                  // if (window._hmt) {
                  //   window._hmt.push(['_trackEvent', 'funcTracker', 'click', '做任务_click'])
                  // }
                  // this.$router.push({ path: '/taskPage' })
                  this.toShellPay('db_ymy_n_gn')
                  model()
                }
              },
              {
                top: '80',
                bottom: '7',
                left: '5',
                right: '5',
                click: () => {
                  if (window._hmt) {
                    window._hmt.push(['_trackEvent', 'funcTracker', 'click', '加入会员_click'])
                  }
                  this.toVip('svip_daan5_hymf_gn')
                }
              }
            ]
          })
        }
        return false
      }
      this.$router.push({
        path: 'answerPage',
        query: {
          workbook_id: this.workbook_id,
          chapter: item.id,
          pageId: page.id,
          isCollect: this.$refs.shujiaRef.isAdd,
          category: this.catalogueData.category
        }
      })
    },
    toVip(channel) {
      if (channel === '99ZYB_ymy_1_gn') {
        window.location.href =
          '/cms/webapp/home/user/userCenter.html#/payAnswerActive?channel=99ZYB_ymy_1_gn'
      } else {
        window.location.href = `/cms/webapp/home/vipPay/index.html?channel=${channel}`
      }
    },
    // 获取前五页免费
    // getPreIndex() {
    //   return this.$store
    //     .dispatch('answerRight/getPreIds', { workbookId: this.workbook_id })
    //     .then((ids) => {
    //       this.ids = ids
    //     })
    // },
    // pageIndex(page) {
    //   return !this.ids.includes(page.id)
    // },
    related() {
      // window.location.href = `/cms/static/hwVideoHtml/relative_video.html?wbId=${this.workbook_id}&v=1&grade=${this.catalogueData.grades[0]}&volume=${this.catalogueData.volume}&course=${this.catalogueData.course}`
      window.location.href = '/cms/webapp/home/home.html#/more_zhishishipin'
    },
    // 获取页码页数据json
    getBookPageJosn(workbook_id) {
      return this.$store.dispatch('answerRight/getBookContent', { workbookId: workbook_id })
    },
    // 可维护弹窗
    getModal() {
      return getMopaAd(
        {
          code: 'answerPage', // 页面
          cCodes: 'answerPage_bottom' // 页面位置
        },
        this.$store.userInfo.vipLevel.toUpperCase(),
        this.$env.isIos
      ).then((res) => {
        if (res) {
          const videoCourseAd = res[0]
          videoCourseAd &&
            open({
              name: 'AdvertAnswerDetail',
              options: {
                imageUrl: videoCourseAd.imgPath,
                link: videoCourseAd.urlPath,
                needAdPrint: videoCourseAd.externalOrg
              },
              expired: true
            })
        }
      })
    },
    textBookAd() {
      return getMopaAd(
        {
          code: 'answerPage', // 页面
          cCodes: 'textBookBottom' // 页面位置
        },
        this.$store.userInfo.vipLevel.toUpperCase(),
        this.$env.isIos
      ).then((res) => {
        if (this.userInfo.vipLevel === 'nv' && res.length === 0) {
          // renderTCAD({
          //   index: 0,
          //   success(ad) {
          //     ad.style.bottom = '1.7rem'
          //   }
          // })
        }
        if (res && res.length > 0 && this.$store.userInfo.vipLevel === 'nv') {
          // 随机展示每一项
          this.BottomTengImgList = true
          var Manthimg = Math.floor(Math.random() * res.length)
          this.BottomTengImg = res[Manthimg].imgPath
          this.BottomTengImglink = res[Manthimg].urlPath
          this.externalOrg = res[Manthimg].externalOrg
        }
      })
    },
    // 即将上线的书  获取是否订阅
    getWbOnlineSubscribe() {
      this.$http
        .post(
          '/cms/weixin/hw/getWbOnlineSubscribe',
          qs({ openid: this.openid, wbId: this.workbook_id })
        )
        .then((res) => {
          if (res.data.id) {
            this.subscribe = true
          }
        })
    },
    // 即将上线的书  订阅操作
    subscribeWbOnlineInfo() {
      this.$http
        .post(
          '/cms/weixin/hw/subscribeWbOnlineInfo',
          qs({ openid: this.openid, wbId: this.workbook_id })
        )
        .then((res) => {
          if (res) {
            this.subscribe = true
          }
        })
    },
    testTongji() {
      if (window.Statistic) {
        const {
          openid,
          userInfo: { vipLevel, wbGrade, isRead, isCourse }
        } = this.$store
        window.Statistic.trackEvent({
          app: 'shanxiCms',
          source: 'mopa',
          category: '1',
          action: 'view',
          label: '页码页',
          openid,
          vip: vipLevel || '',
          label1: this.workbook_id,
          wbType: this.$business.transformCategory(this.catalogueData.category || ''),
          userGrade: wbGrade,
          userType: (isRead || '') + ':' + (isCourse || '')
        })
      }
    },
    // 检查暑假作业订阅状态，判断是否需要弹窗
    // checkSummerAssignmentSubscriptionStatus() {
    //   this.$http
    //     .post(`/cms/weixin/wb/answerPageIsSubscription?openid=${this.openid}`)
    //     .then(({ data }) => {
    //       if (!data.isSubscription) {
    //         open({
    //           name: 'SummerAssignmentSubscription',
    //           expired: true
    //         })
    //       }
    //     })
    // }
    // 单本售卖去创建确认订单
    channelCheckedTerm() {
      this.checkedtermAlert = false
    },
    // 单本售卖去创建确认订单 9月初-1月底，是上学期，2月初-8月底是下学期
    toShellPay(channel, isToPayment) {
      /**
       * isToPayment  二次确认弹窗判断参数
       */
      this.$trackevent({
        type: 'funcTracker',
        action: 'click',
        opt_label: '立即订阅按钮'
      })
      var now = new Date()
      var Month = now.getMonth() + 1

      if (Month >= 2 && Month <= 8) {
        var trem = 2
      } else {
        trem = 1
      }
      if (this.catalogueData.volume === 3 && channel === 'db_ymy_n_gn') {
        this.topAlertisShow = true
        if (isToPayment) {
          this.$router.push({
            path: 'bookOrder',
            query: { id: this.workbook_id, channel: channel }
          })
        }
        return
      }
      // 二次确认学期弹窗 不是当前学期提示
      if (trem !== this.catalogueData.volume && channel === 'db_ymy_n_gn') {
        // this.checkedtermAlert = true
        this.topAlertisShow = true
        this.bookVolume = true
        return false
      } else if (trem === this.catalogueData.volume && channel === 'db_ymy_n_gn') {
        // 二次确认学期弹窗 是当前学期提示  底部按钮
        this.topAlertisShow = true
        if (isToPayment) {
          this.$router.push({
            path: 'bookOrder',
            query: { id: this.workbook_id, channel: channel }
          })
        }
      } else if (trem === this.catalogueData.volume && channel === 'db_tch_1_gn') {
        // 二次确认学期弹窗 是当前学期提示  页码页弹窗
        this.topAlertisShow = true
        if (isToPayment) {
          this.$router.push({
            path: 'bookOrder',
            query: { id: this.workbook_id, channel: channel }
          })
        }
      } else if (trem !== this.catalogueData.volume && channel === 'db_tch_1_gn') {
        // this.checkedtermAlert = true
        this.topAlertisShow = true
        this.bookVolume = true // 是否为本册次书籍
        return false
      } else {
        // 弹窗：db_tch_1_gn
        // 页码页：db_ymy_n_gn
        this.$router.push({
          path: 'bookOrder',
          query: { id: this.workbook_id, channel: channel }
        })
      }
    },
    async tip() {
      const hash = u.path.hash.t(1)
      const v = u.db.st.user.userInfo.vipLevel
      // 点读只有sv和点读会员展示
      if (hash.startsWith('/dianDuBooks')) {
        if (this.$store.state.user.userInfo.isRead === 'N' && v === 'nv') {
          return
        }
      } else if (hash.startsWith('/mjBooks')) {
        // 密卷只有sv
        if (v !== 'sv') {
          return
        }
      } else if (this.isAnswer) {
        console.log('wo zai zheli ', this.isAnswer)
        return
      } else if (v === 'nv') {
        // 其他的是gv sv
        return
      }
      // 书籍id
      const id = u.qs(hash.t('?')[1])['id']
      const td = u.tm().t(' ')[0]
      var h = await fsc('ymy_hyts')
      if (!h || !h.startsWith(td)) {
        await fsc('ymy_hyts', td + ':')
      }
      h = await fsc('ymy_hyts')
      if (h.includes(id)) return
      const imgObj = {
        sv: 'https://img01.yzcdn.cn/upload_files/2021/05/17/FiDdP93wCVbiXK1fyFs5Hun2pz0R.png',
        gv: 'https://img01.yzcdn.cn/upload_files/2021/05/17/FgS-hmWfJseZHl0yIhTewmKPzNnz.png',
        read: 'https://img01.yzcdn.cn/upload_files/2021/05/19/FmzC4v3MKD4r3sn6Z4AKi-NQGQri.jpg'
      }
      var i = imgObj[v]
      if (hash.startsWith('/dianDuBooks') && this.$store.state.user.userInfo.isRead === 'Y') {
        i = imgObj[v !== 'nv' ? v : 'read']
      }
      u.qi('body > img#i0') || u.bd.h(2, `<img id=i0 src=${i}>`)
      // 设置样式
      u.id('i0').s(
        `position: fixed; top: -1.07rem; z-index: 99999; max-width:100%; background-color: white; transition: top 2.5s;`
      )
      // setTimeout
      setTimeout(() => {
        u.id('i0').s('top: 0')
      }, 0)
      setTimeout(() => {
        u.id('i0').s('top: -1.07rem')
      }, 5000)

      fsc('ymy_hyts', h + ',' + id)
    },
    // 作业宝活动跳转链接
    ZybToVip(channel) {
      this.$trackevent({
        type: 'funcTracker',
        action: 'click',
        opt_label: '99vip'
      })
      window.location.href = `/cms/webapp/home/activities/#/zybPay?channel=${channel}`
    }
  }
}
</script>

<style scoped lang="scss">
.books {
  position: absolute;
  width: 84px;
  height: 30px;
  right: 17px;
  bottom: 10px;
  // background: #FF2638;
  border-radius: 4px;
  font-weight: bold;
  font-size: 12px;
  color: white;
}

.books > img {
  max-width: 100%;
}

#banner_2_0 {
  position: fixed;
  width: 100%;
}

.TCAD_pageNum {
  bottom: 1.36rem;
}

.outerAd {
  position: relative;
}

.outerAd::before {
  content: '广告';
  width: 29px;
  height: 16px;
  line-height: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 11;
  left: 0px;
  top: 0px;
  font-family: PingFangSC, Sans-serif, -apple-system, Arial, sans-serif !important;
  font-size: 10px !important;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  color: #ffffff;
}

.byOneself_AD {
  position: fixed;
  left: 0;
  bottom: 1.36rem;

  .byOneself_AD-img {
    width: 100vw;
    height: 56px;
  }

  .byOneself_AD-close {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 4px;
    top: 4px;
  }
}

.page {
  border-top: 0.5px solid #f5f5f5;
  width: 100%;
  background: #ffffff;
  min-height: 100vh;
  overflow: auto;
  // 间隔0.21rem
  .book-year {
    position: absolute;
    top: 0%;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .mb21 {
    width: 100%;
    height: 0.21rem;
    background: rgba(249, 249, 249, 1);
  }

  .top {
    width: 100%;
    height: 1.2rem;
    display: flex;
    align-items: center;

    p {
      display: inline-block;
      width: 1.48rem;
      font-size: 0.32rem;
      line-height: 0.77rem;
      color: rgba(51, 51, 51, 1);
      background: url('https://img.yzcdn.cn/upload_files/2020/04/03/FjdPBims__fR87pn2l24J7e1yWiT.png')
        no-repeat;
      background-size: 1.48rem 0.77rem;
      margin-left: -2px;

      img {
        display: inline-block;
        width: 0.19rem;
        height: 0.33rem;
        margin-left: 0.2rem;
        margin-right: 0.11rem;
        position: relative;
        top: 1px;
      }
    }
  }

  .sameQuestionTip {
    height: 27px;
    margin: 10px 16px 0px 16px;
    background: #fceeef;
    border-radius: 4px;

    img {
      width: 11px;
      margin-left: 24px;
      margin-right: 6px;
    }

    span {
      font-size: 11px;
      color: #ff2638;
    }
  }

  .main {
    padding: 0.62rem 0.4rem 0.4rem;
    margin-bottom: 85px;
    //margin-bottom: 1.36rem;

    .book_detail {
      width: 9.2rem;
      height: 3.39rem;
      position: relative;
      background: rgba(255, 255, 255, 1);
      border-radius: 0.11rem;
      box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.06);

      .newest2 {
        position: absolute;
        top: 0;
        left: 0;
        margin: auto;
        width: 28px;
        height: 15px;
        display: flex;
        justify-content: center;
        background: linear-gradient(293.48deg, #f55a53 10.33%, #ff7b6b 108.87%);
        border-radius: 4px 0;
        background: url(https://img01.yzcdn.cn/upload_files/2021/11/12/Fq_TPVtUwGBGFdSQURI7cF7emap-.png)
          no-repeat;
        background-size: contain;
        //z-index: 1;
      }

      //.newest2:after {
      //  content: '最新';
      //  line-height: 15px;
      //  color: #ffffff;
      //  font-size: 10px;
      //  font-weight: 500;
      //}

      .isAnswer {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 21px;
        display: flex;
        justify-content: center;
        background: linear-gradient(104.23deg, #fc7365 17.52%, #f55b53 69.38%);
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
      }

      .isAnswer:after {
        line-height: 21px;
        content: '仅参考答案';
        color: #ffffff;
        font-size: 12px;
        font-weight: 300;
      }

      .book_img {
        position: absolute;
        left: 0.32rem;
        top: -0.32rem;

        .mask {
          width: 2.45rem;
          height: 3.39rem;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          flex-direction: column;
          align-content: center;
          align-items: center;
          justify-content: center;
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          border-radius: 0.07rem;

          .mask_img {
            width: 0.48rem;
            height: 0.49rem;
            margin-bottom: 10px;
          }

          .name {
            font-size: 0.27rem;
            font-family: PingFang SC;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            line-height: 0.36rem;
            margin-top: -0.13rem;
          }
        }

        .img,
        img {
          width: 2.45rem;
          height: 3.39rem;

          border-radius: 5px;
          // border: 1px solid rgba(237, 237, 237, 1);
          box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
        }
      }

      .book_title {
        box-sizing: border-box;
        float: right;
        width: calc(100% - 3.24rem);
        height: 100%;
        padding: 10px 0;

        .book_sub_title_one {
          font-size: 10px;
          color: #ff8126;
        }

        .book_sub_title_two {
          width: 130px;
          font-size: 12px;
          display: flex;
          height: 32px;
          position: absolute;
          bottom: 0.32rem;
          // justify-content: center;
          // line-height: 52px;
          // margin-top: 26px;
          // padding-top: 23px;
          box-sizing: border-box;
          align-items: center;
          color: #808080;
        }

        .book_sub_title_pub {
          margin-top: 10px;
          padding: 2px 4px;
          background: rgba(255, 129, 38, 0.1);
        }

        .book_sub_title_gc {
          margin-left: 6px;
        }

        .relactive {
          font-size: 0.32rem;
          line-height: 1;
          color: #ff2638;
          display: flex;
          align-items: center;
          position: absolute;
          bottom: 0.32rem;

          img {
            width: 10px;
            line-height: 10px;
            margin-top: 1px;
          }
        }

        h3 {
          font-size: 14px;
          color: #333333;
          line-height: 21px;
          margin-right: 0.68rem;
          display: -webkit-box;
          height: 39px;
          overflow: hidden;
          white-space: normal !important;
          text-overflow: ellipsis;
          word-wrap: break-word;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        p {
          color: #b2b2b2;
          font-size: 0.32rem;
          margin-right: 0.68rem;
          line-height: 0.45rem;
          display: -webkit-box;
          overflow: hidden;
          white-space: normal !important;
          text-overflow: ellipsis;
          word-wrap: break-word;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
    }

    .remind {
      margin-top: 15px;
      display: flex;
      align-items: center;
      padding-left: 8px;
      width: 346px;
      height: 28px;
      line-height: 28px;
      background: #fceeef;
      border-radius: 4px;
      text-align: center;

      span {
        margin-right: 4px;
        font-size: 11px;
        color: #ff2638;
      }

      img {
        height: 7px;
      }
    }

    .catalogue {
      .catalogue_title {
        font-size: 0.43rem;
        font-weight: 400;
        color: #333333;
        line-height: 1.5;
        margin-bottom: 0.53rem;
        padding-top: 0.85rem;
      }

      .catalogue_number {
        display: inline-block;
        color: #333333;
        position: relative;

        .noright {
          margin-right: 0;
        }

        span {
          display: inline-block;
          width: 1.28rem;
          height: 1.28rem;
          background: #f5f5f9;
          border-radius: 0.13rem;
          font-size: 0.37rem;
          text-align: center;
          line-height: 1.28rem;
          margin-right: 0.29rem;
          margin-bottom: 0.36rem;

          &.border_red {
            background: rgba(255, 237, 239, 1);
            border: 1px solid rgba(255, 54, 71, 1);
            color: rgba(255, 54, 71, 1);
          }
        }

        .lock {
          width: 1.28rem;
          height: 0.4rem;
          background: #000000;
          opacity: 0.5;
          border-radius: 0px 0px 0.13rem 0.13rem;
          position: absolute;
          bottom: 0.32rem;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 8px;
            height: 10px;
          }
        }
      }
    }

    .no_up_page {
      margin-top: 1.13rem;
      text-align: center;

      img {
        width: 2.6rem;
        margin: 0 auto;
      }

      .tip_top {
        font-size: 0.4rem;
        color: rgba(77, 77, 77, 1);
        margin-top: 0.55rem;
        margin-bottom: 0.2rem;
      }

      .tip_middle {
        font-size: 0.35rem;
        color: rgba(128, 128, 128, 1);
        margin-bottom: 0.53rem;
      }

      button {
        width: 2.48rem;
        height: 0.8rem;
        background: linear-gradient(90deg, rgba(255, 139, 62, 1), rgba(239, 66, 70, 1));
        border-radius: 0.4rem;
        font-size: 0.35rem;
        line-height: 0.8rem;
        color: rgba(255, 255, 255, 1);

        &.gray {
          background: #999;
        }
      }
    }
  }
  .baidu_fixed_wrap {
    height: 1.6rem;
    .baidu_textBook {
      position: fixed;
      bottom: 2.1rem;
    }
  }
}

.Answer_Tips {
  width: 345px;
  height: 82px;
  padding: 12px 13px;
  font-size: 12px;
  background: #fffaf7;
  border-radius: 4px;
  color: #333;
  line-height: 19px;
  margin-top: 20px;

  .Answer_Tips_title {
    margin-bottom: 4px;
  }

  .Answer_Tips_desc_red {
    color: red;
  }
}

.answer_bottom {
  position: fixed;
  left: 0;
  bottom: 0;
  height: 85px;
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 6px rgba(167, 167, 167, 0.1);
  display: flex;
  justify-content: center;

  .answer_bottom_btn {
    margin-top: 11.5px;
    width: 338px;
    height: 44px;
    background: #ff2638;
    border-radius: 6px;
    color: #ffffff;
    font-size: 15px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
